import React from 'react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const linkedTxtPrefix = 'Get to know';

var articles = [];
var carousel = document.querySelector('#carousel');
var data = [];
var i = 0;

// Function to wait for images to load with timeout
function waitForImages(callback, timeout = 10000) {
  const startTime = Date.now();

  function checkImages() {
    const images = carousel.getElementsByTagName('img');
    let allLoaded = true;

    if (images.length === 0) {
      // No images found yet, keep waiting
      allLoaded = false;
    } else {
      for (let i = 0; i < images.length; i++) {
        if (!images[i].src || images[i].src === '' || images[i].src === window.location.href) {
          allLoaded = false;
          break;
        }
      }
    }

    if (allLoaded || (Date.now() - startTime) > timeout) {
      callback();
    } else {
      setTimeout(checkImages, 200);
    }
  }

  checkImages();
}

if (carousel) {
  articles = carousel.getElementsByTagName('article');

  // Wait for Acquia DAM images to load asynchronously
  waitForImages(() => {
    for (i = 0; i < articles.length; i++) {
      let img = articles[i].getElementsByTagName('img');
      let anchor = articles[i].getElementsByTagName('a');
      let nameFirst = articles[i].getElementsByClassName('field-name-first');
      let nameFull = articles[i].getElementsByClassName('field-name-full');
      let occupation = articles[i].getElementsByClassName('field-occupation');

      data[i] = {
        'alt': img[0] ? (img[0].alt || '') : '',
        'href': anchor[0] ? (anchor[0].href || '') : '',
        'nameFirst': nameFirst[0] ? (nameFirst[0].innerText || '') : '',
        'nameFull': nameFull[0] ? (nameFull[0].innerText || '') : '',
        'occupation': occupation[0] ? (occupation[0].innerText || '') : '',
        'title': img[0] ? (img[0].alt || '') : '',
        'src': img[0] ? (img[0].src || img[0].getAttribute('src') || '') : '',
      };
    }
  });
}
const styleBody = {
  color: '#65665f',
  fontFamily: 'greta text,Georgia,times new roman,Times,serif',
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '18px',
  margin: '0.25rem 1.0rem 0.25rem 0',
};
const styleContent = {
  maxWidth: '70%',
}
const styleImg = {
  maxWidth: '70%',
}
const styleLink = {
  color: '#171a13',
  fontFamily: '"Greta Text",Georgia,"Times New Roman",Times,serif',
  fontWeight: '400',
  lineHeight: '1',
  margin: '0',
  textTransform: 'none',
};
const styleTitle = {
  fontSize: '16px',
  lineHeight: '16px',
  margin: '1.0rem 1.0rem 0.25rem 0',
};
const stylePrev = {
  zIndex: 1000,
};
const styleNext = {
  zIndex: 1000,
};
const stylePagination = {
  zIndex: 1000,
  textAlign: 'center',
};


function getSlideHref(data, index) {
  return data[index].href;
}

function getImgAlt(data, index) {
  return data[index].alt;
}

function getImgSrc(data, index) {
  return data[index].src;
}

function getSlideNameFirst(data, index) {
  return data.slides[index.i].nameFirst;
}

function getSlideNameFull(data, index) {
  return data.slides[index.i].nameFull;
}

function getSlideOccupation(data, index) {
  return data.slides[index.i].occupation;
}
const Carousel = () => {
  const slides = data;

  // Add CSS for Swiper's auto-generated pagination
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      #carousel .swiper-container {
        height: auto !important;
      }
      .sfp-carousel {
        position: relative;
        padding-bottom: 40px !important;
      }
      .sfp-carousel .swiper-pagination {
        position: absolute !important;
        bottom: 5px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        width: auto !important;
        text-align: center !important;
        z-index: 1000;
      }
      /* Use Swiper's default bullet styling - no custom sizing */
    `;
    document.head.appendChild(style);

    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  return (
    <Swiper
      centeredSlides={true}
      className='sfp-carousel'
      grabCursor={true}
      loop={true}
      pagination={{
        clickable: true,
        dynamicBullets: false,
        hideOnClick: false,
        renderBullet: function (index, className) {
          return '<span class="' + className + '" style="margin: 0 4px;"></span>';
        }
      }}
      overflow={{ hidden: true }}
      navigation={{
        nextEl: '.swiper-button-prev',
        prevEl: '.swiper-button-next',
      }}
      breakpoints={{
        300: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1920: {
          slidesPerView: 4,
          spaceBetween: 60,
        },
      }}
    >
      {slides.map((_, i) => (<SwiperSlide key={i} virtualIndex={i}>
        <div className="carousel-content" style={styleContent}>
          <img src={getImgSrc(slides, i)} style={styleImg} alt={getImgAlt(slides, i)} />
          <p className="carousel-title coh-paragraph coh-style-preheading" style={styleTitle}>{getSlideNameFull({slides}, {i})}</p>
          <p className="carousel-body coh-paragraph coh-style-type-system-body" style={styleBody}>{getSlideOccupation({slides}, {i})}</p>
          <a className="carousel-link coh-link coh-style-button-link-with-icon-on-light-background" style={styleLink} href={getSlideHref(slides, i)}>{linkedTxtPrefix} {getSlideNameFirst({slides}, {i})}</a>
        </div>
      </SwiperSlide>))}
      <div className="swiper-button-prev" style={stylePrev}></div>
      <div className="swiper-button-next" style={styleNext}></div>
    </Swiper>
  );
};
export default Carousel;
